"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721Metadata = exports.ERC721 = void 0;
// tslint:disable:max-line-length
const abi_1 = require("./abi");
const bitwise_1 = require("./bitwise");
const ApprovalABI = {
    anonymous: false,
    inputs: [
        { indexed: true, name: 'owner', type: 'address' },
        { indexed: true, name: 'approved', type: 'address' },
        { indexed: true, name: 'tokenId', type: 'uint256' },
    ],
    name: 'Approval',
    type: 'event',
};
const TransferABI = {
    anonymous: false,
    inputs: [
        { indexed: true, name: 'from', type: 'address' },
        { indexed: true, name: 'to', type: 'address' },
        { indexed: true, name: 'tokenId', type: 'uint256' },
    ],
    name: 'Transfer',
    type: 'event',
};
const ApprovalForAllABI = {
    anonymous: false,
    inputs: [
        { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
        { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
        { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
    ],
    name: 'ApprovalForAll',
    type: 'event',
};
const approveABI = {
    inputs: [
        { name: 'to', type: 'address' },
        { name: 'tokenId', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
};
const balanceOfABI = {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
};
const getApprovedABI = {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
};
const isApprovedForAllABI = {
    inputs: [
        { internalType: 'address', name: 'owner', type: 'address' },
        { internalType: 'address', name: 'operator', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
};
const ownerOfABI = {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
};
const safeTransferFromABI = {
    inputs: [
        { internalType: 'address', name: 'from', type: 'address' },
        { internalType: 'address', name: 'to', type: 'address' },
        { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
};
const safeTransferFrom2ABI = {
    inputs: [
        { internalType: 'address', name: 'from', type: 'address' },
        { internalType: 'address', name: 'to', type: 'address' },
        { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        { internalType: 'bytes', name: '_data', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
};
const setApprovalForAllABI = {
    inputs: [
        { internalType: 'address', name: 'operator', type: 'address' },
        { internalType: 'bool', name: 'approved', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
};
const transferFromABI = {
    inputs: [
        { internalType: 'address', name: 'from', type: 'address' },
        { internalType: 'address', name: 'to', type: 'address' },
        { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
};
// ERC721 metadata
const nameABI = {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
};
const symbolABI = {
    inputs: [],
    name: 'symbol',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
};
const tokenURIABI = {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
};
const Transfer = new abi_1.abi.Event(TransferABI);
const Approval = new abi_1.abi.Event(ApprovalABI);
const ApprovalForAll = new abi_1.abi.Event(ApprovalForAllABI);
const balanceOf = new abi_1.abi.Function(balanceOfABI);
const ownerOf = new abi_1.abi.Function(ownerOfABI);
const safeTransferFrom2 = new abi_1.abi.Function(safeTransferFrom2ABI);
const safeTransferFrom = new abi_1.abi.Function(safeTransferFromABI);
const transferFrom = new abi_1.abi.Function(transferFromABI);
const approve = new abi_1.abi.Function(approveABI);
const setApprovalForAll = new abi_1.abi.Function(setApprovalForAllABI);
const getApproved = new abi_1.abi.Function(getApprovedABI);
const isApprovedForAll = new abi_1.abi.Function(isApprovedForAllABI);
exports.ERC721 = {
    Transfer,
    Approval,
    ApprovalForAll,
    balanceOf,
    ownerOf,
    safeTransferFrom,
    safeTransferFrom2,
    transferFrom,
    approve,
    setApprovalForAll,
    getApproved,
    isApprovedForAll,
    interfaceID: (0, bitwise_1.XORBatch)(balanceOf.signature, ownerOf.signature, safeTransferFrom.signature, safeTransferFrom2.signature, transferFrom.signature, approve.signature, setApprovalForAll.signature, getApproved.signature, isApprovedForAll.signature),
};
const name = new abi_1.abi.Function(nameABI);
const symbol = new abi_1.abi.Function(symbolABI);
const tokenURI = new abi_1.abi.Function(tokenURIABI);
exports.ERC721Metadata = {
    name,
    symbol,
    tokenURI,
    interfaceID: (0, bitwise_1.XORBatch)(name.signature, symbol.signature, tokenURI.signature),
};
//# sourceMappingURL=data:application/json;base64,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